
import React from 'react';

interface NoiseBackgroundProps {
  children: React.ReactNode;
  containerClassName?: string;
  gradientColors?: string[];
  className?: string;
}

export const NoiseBackground = ({
  children,
  containerClassName = "",
  gradientColors = ["rgb(99, 102, 241)", "rgb(168, 85, 247)", "rgb(236, 72, 153)"],
  className = ""
}: NoiseBackgroundProps) => {
  return (
    <div className={`relative overflow-hidden group ${containerClassName}`}>
      {/* Animated Gradient Layer */}
      <div 
        className="absolute inset-[-200%] opacity-100 transition-opacity duration-500 group-hover:opacity-100"
        style={{
          background: `conic-gradient(from 0deg, transparent, ${gradientColors.join(', ')}, transparent)`,
          animation: 'spin 4s linear infinite',
        }}
      />
      
      {/* Noise Overlay */}
      <div className="absolute inset-0 opacity-30 mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />

      <div className={`relative z-10 h-full w-full ${className}`}>
        {children}
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
